import React, { ReactElement } from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react-lite';
import UiKit from '../../../../../shared/ui/ui-kit';
import { colorsPalette } from '../../../../../shared/ui/styles/colors-palette';
import { SubmittingStatus } from '../../../../../shared/infrastructure/types/common/common-types';
import { useTranslation } from 'react-i18next';
import { useUILogic } from '../../../shared/providers/UILogicProvider/hooks';

interface RecoveryRequestFormProps {}

let RecoveryRequestForm = function ({}: RecoveryRequestFormProps): ReactElement {
  const { t } = useTranslation();
  const { authorizationUiModule } = useUILogic();
  const restoreUIManager = authorizationUiModule.restorePasswordUIManager;
  const coreManager = restoreUIManager.coreManager;

  return (
    <Wrapper>
      <Header>
        <Heading>{t('recovery.heading')}</Heading>
        <Description>{t('recovery.description')}</Description>
      </Header>
      <FieldsGroup>
        <UiKit.form.Item.VerticalLayoutTemplate label={t('recovery.label.email')}>
          <UiKit.form.Validation
            validateStatus={coreManager.validator.email.isValid ? '' : 'error'}
            message={t(coreManager.validator.email.errors[0]) as string}
            turnValidation={coreManager.formStatus === SubmittingStatus.ERROR_SUBMITTING}
          >
            <UiKit.Input
              value={coreManager.email}
              onChange={value => coreManager.setEmail(value as LoginEmail)}
            />
          </UiKit.form.Validation>
        </UiKit.form.Item.VerticalLayoutTemplate>
        <RememberLink
          onClick={() => {
            coreManager.reset();
            authorizationUiModule.module.openLoginPage();
          }}
        >
          {t('recovery.rememberedPassword')}
        </RememberLink>
      </FieldsGroup>
      <UiKit.Button
        loading={coreManager.formStatus === SubmittingStatus.SUBMITTING}
        customStyles={{ width: '100%' }}
        type="primary"
        onClick={() => coreManager.submitRecoveryRequest()}
      >
        {t('recovery.submit.button')}
      </UiKit.Button>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;
const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
const Heading = styled.div`
  font-family: 'SkorozvonRoboto';
  font-weight: 500;
  font-size: 38px;
  line-height: 46px;
  color: ${colorsPalette.gray700};
  text-align: center;
`;
const Description = styled.div`
  font-size: 12px;
  line-height: 20px;
  color: ${colorsPalette.gray300};
  text-align: left;
`;
const FieldsGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
const RememberLink = styled.div`
  width: fit-content;
  font-size: 14px;
  line-height: 22px;
  color: ${colorsPalette.gray600};
  text-decoration: underline;
  cursor: pointer;
`;

RecoveryRequestForm = observer(RecoveryRequestForm);

export { RecoveryRequestForm };
